import { useCallback } from 'react';
import { useEvent } from 'react-use-v13';

function usePreventWindowUnload(shouldPrevent: boolean, message = '') {
  const onBeforeUnload = useCallback(
    (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    },
    [message],
  );

  useEvent('beforeunload', shouldPrevent ? onBeforeUnload : undefined, window);
}

export default usePreventWindowUnload;
